// extracted by mini-css-extract-plugin
export default {"pagerWrapper":"Pager_pagerWrapper__gO8e2","pagerButton":"Pager_pagerButton__rwMov","separator":"Pager_separator__NapTL","big":"Pager_big__zNCxx"};